import React from 'react';
import {
	HStack,
	Box,
	Text,
	Textarea,
	Image,
	Tabs,
	Button,
	VStack,
	Separator,
	Heading,
	Spacer,
	Portal,
	Dialog,
	List,
	CloseButton
} from '@chakra-ui/react';
import SignaturePad from '../components/SignaturePad';
import AttachmentsList from '../components/AttachmentsList';
import PhotoAttachments from '../components/PhotoAttachments';
import { addAttachment, deleteAttachment } from '../lib/attachments';
import moment from 'moment';
import { FaImage } from 'react-icons/fa';
import theme from '../theme';

const Sketches = ({
	attachments: sketches,
	formTitle,
	attachmentType,
	currentPacketId,
	currentFormId,
	saveForm,
	activeLog,
	navDrawerEnabled,
	navDrawerOpen,
	removeAttachment,
	readOnly
}) => {
	const [errorDialog, setErrorDialog] = React.useState(null);
	const [newSketch, setNewSketch] = React.useState('');
	const [sketchPadOpen, setSketchPadOpen] = React.useState(false);
	const [comment, setComment] = React.useState('');

	const errorModalRef = React.useRef();

	return (
		<>
			<Dialog.Root
				role="alertdialog"
				initialFocusEl={errorModalRef}
				onOpenChange={({ open }) => {
					if (!open) {
						setErrorDialog(null);
					}
				}}
				open={errorDialog}
				placement="center"
			>
				<Portal>
					<Dialog.Backdrop />
					<Dialog.Positioner>
						<Dialog.Content opacity="1 !important">
							<Dialog.Header>
								<Dialog.Title fontSize="lg" fontWeight="bold">
									Error Adding Sketch Attachment
								</Dialog.Title>
							</Dialog.Header>
							<Dialog.Body>
								<p>{errorDialog}</p>
							</Dialog.Body>
							<Dialog.Footer>
								<Dialog.ActionTrigger asChild>
									<Button
										ref={errorModalRef}
										ml={3}
										color={theme.colors.white}
										bg={theme.colors.blue[700]}
										_hover={{ backgroundColor: theme.colors.blue[800] }}
										onClick={() => setErrorDialog(null)}
									>
										Okay
									</Button>
								</Dialog.ActionTrigger>
							</Dialog.Footer>
							<Dialog.CloseTrigger asChild>
								<CloseButton size="sm" />
							</Dialog.CloseTrigger>
						</Dialog.Content>
					</Dialog.Positioner>
				</Portal>
			</Dialog.Root>
			{sketchPadOpen && (
				<Portal>
					<Box
						position="absolute"
						top="82px"
						left={!navDrawerEnabled || navDrawerOpen ? '630px' : 0}
						width={!navDrawerEnabled || navDrawerOpen ? 'calc(100% - 630px)' : '100%'}
						height="calc(100% - 97px)"
						zIndex={5}
						bg="rgba(50, 50, 50, 0.75)"
						onClick={() => setSketchPadOpen(false)}
						transition="400ms"
						transitionTimingFunction="ease-in-out"
					>
						<Box
							position="relative"
							w="calc(100% - 100px)"
							h="calc(100% - 100px)"
							left="50px"
							top="50px"
							bgColor={theme.colors.white}
							padding="8px"
							zIndex={10}
							onClick={e => e.stopPropagation()}
						>
							<SignaturePad
								height="calc(100% - 50px)"
								disabled={false}
								defaultEdit={true}
								navDrawerEnabled={navDrawerEnabled}
								navDrawerOpen={navDrawerOpen}
								onSign={signatureData => {
									setNewSketch(signatureData);
									setSketchPadOpen(false);
								}}
							/>
						</Box>
					</Box>
				</Portal>
			)}
			{!readOnly ? (
				<VStack m="16px">
					<Text as="label" position="relative" alignSelf="flex-start" fontWeight="bold">
						Add Sketch Form
					</Text>
					<HStack position="relative" w="100%" spacing="16px">
						<VStack
							w="225px"
							h="225px"
							alignItems="center"
							justifyContent="center"
							cursor="pointer"
							border="3px dashed #d5d5d5"
							onClick={() => setSketchPadOpen(true)}
						>
							{newSketch ? (
								<Image flex={1} h="225px" src={newSketch} />
							) : (
								<>
									<FaImage size="7x" />
									<Text>Add Sketch</Text>
								</>
							)}
						</VStack>
						<VStack flex={1} h="225px" align="flex-start">
							<Text fontWeight="bold">Note</Text>
							<Textarea h="100%" value={comment} onChange={({ target }) => setComment(target.value)} />
						</VStack>
					</HStack>
					<HStack w="100%" justify="flex-end" spacing="16px">
						<Button
							ml="12px"
							disabled={!newSketch}
							color={theme.colors.white}
							bg={theme.colors.blue[700]}
							textTransform="capitalize"
							_hover={{ backgroundColor: theme.colors.blue[800] }}
							onClick={() =>
								addAttachment({
									attachment_comment: comment,
									attachment_type: attachmentType,
									form_id: currentFormId,
									form_title: formTitle,
									file: {
										uri: `/sketch_${currentPacketId}_${Date.now()}.png`,
										base64: newSketch
									},
									attachment_creator: localStorage.getItem('username'),
									attachment_diver: activeLog,
									packet_id: currentPacketId
								})
									.then(attachment => {
										saveForm(attachment, true);
										setNewSketch('');
										setComment('');
									})
									.catch(error => setErrorDialog(error.message))
							}
						>
							Save Sketch
						</Button>
					</HStack>
				</VStack>
			) : null}
			<AttachmentsList
				attachments={sketches}
				currentPacketId={currentPacketId}
				attachmentType={attachmentType}
				saveForm={saveForm}
				navDrawerEnabled={navDrawerEnabled}
				navDrawerOpen={navDrawerOpen}
				removeAttachment={removeAttachment}
				readOnly={readOnly}
			/>
		</>
	);
};

// NOTE: This is now notes
const Comments = ({
	attachments: comments,
	formTitle,
	attachmentType,
	currentPacketId,
	currentFormId,
	saveForm,
	activeLog,
	readOnly
}) => {
	const [errorDialog, setErrorDialog] = React.useState(null);
	const [comment, setComment] = React.useState('');

	const errorModalRef = React.useRef();

	return (
		<>
			<Dialog.Root
				role="alertdialog"
				initialFocusEl={errorModalRef}
				onOpenChange={({ open }) => {
					if (!open) {
						setErrorDialog(null);
					}
				}}
				open={errorDialog}
				placement="center"
			>
				<Portal>
					<Dialog.Backdrop />
					<Dialog.Positioner>
						<Dialog.Content opacity="1 !important">
							<Dialog.Header>
								<Dialog.Title fontSize="lg" fontWeight="bold">
									Error Adding Comment Attachment
								</Dialog.Title>
							</Dialog.Header>
							<Dialog.Body>
								<p>{errorDialog}</p>
							</Dialog.Body>
							<Dialog.Footer>
								<Dialog.ActionTrigger asChild>
									<Button
										ref={errorModalRef}
										ml={3}
										color={theme.colors.white}
										bg={theme.colors.blue[700]}
										_hover={{ backgroundColor: theme.colors.blue[800] }}
										onClick={() => setErrorDialog(null)}
									>
										Okay
									</Button>
								</Dialog.ActionTrigger>
							</Dialog.Footer>
							<Dialog.CloseTrigger asChild>
								<CloseButton size="sm" />
							</Dialog.CloseTrigger>
						</Dialog.Content>
					</Dialog.Positioner>
				</Portal>
			</Dialog.Root>
			{!readOnly ? (
				<VStack mx="16px" mt="16px">
					<Text as="label" alignSelf="flex-start" fontWeight="bold">
						Add Note Form
					</Text>
					<Textarea w="100%" value={comment} onChange={({ target }) => setComment(target.value)} />
					<HStack w="100%" justify="flex-end" spacing="16px">
						<Button
							disabled={!comment}
							color={theme.colors.white}
							bg={theme.colors.blue[700]}
							_hover={{ backgroundColor: theme.colors.blue[800] }}
							onClick={() => {
								addAttachment({
									attachment_comment: comment,
									attachment_type: attachmentType,
									attachment_diver: activeLog,
									packet_id: currentPacketId,
									form_id: currentFormId,
									form_title: formTitle,
									attachment_creator: localStorage.getItem('username')
								})
									.then(attachment => {
										saveForm(attachment, true);
										setComment('');
									})
									.catch(error => setErrorDialog(error.message));
							}}
						>
							Save Note
						</Button>
					</HStack>
				</VStack>
			) : null}
			<List.Root listStyleType="none" m="16px">
				{comments.map(({ id, comment, creator, created }, index) => (
					<List.Item
						key={id}
						borderLeft={`3px solid ${theme.colors.blue[700]}`}
						padding="8px 16px"
						bgColor={index % 2 === 0 ? theme.colors.gray[400] : theme.colors.white}
					>
						<Text>{`${creator} - ${moment(new Date(created)).format('YYYY/MM/DD')}`}</Text>
						<Text fontWeight="bold" whiteSpace="pre-wrap">
							{comment}
						</Text>
					</List.Item>
				))}
			</List.Root>
		</>
	);
};

const Attachments = [PhotoAttachments, Sketches, Comments];

export default ({
	packetTitle,
	activeLog,
	attachmentsIndex,
	setAttachmentsIndex,
	attachments,
	currentProject,
	currentPhase,
	currentPacketId,
	currentFormId,
	saveForm,
	navDrawerEnabled,
	navDrawerOpen,
	readOnly
}) => {
	const [errorDialog, setErrorDialog] = React.useState(null);
	const attachmentLabels = React.useMemo(() => Object.keys(attachments), [attachments?.length]);
	const formTitle = React.useMemo(() => {
		switch (currentFormId) {
			case 'supervisor_handoff':
				return 'Project Information';
			case 'delta_p_field_list':
				return 'Differential Pressure Field Hazards Checklist';
			default:
				return currentFormId ? currentFormId.split('_').join(' ') : 'Packet';
		}
	}, [currentFormId]);

	const errorModalRef = React.useRef();

	return (
		<Box p="16px">
			<Dialog.Root
				role="alertdialog"
				initialFocusEl={errorModalRef}
				onOpenChange={({ open }) => {
					if (!open) {
						setErrorDialog(null);
					}
				}}
				open={Boolean(errorDialog)}
				placement="center"
			>
				<Portal>
					<Dialog.Backdrop />
					<Dialog.Positioner>
						<Dialog.Content opacity="1 !important">
							<Dialog.Header>
								<Dialog.Title fontSize="lg" fontWeight="bold">
									Error Deleting Attachment
								</Dialog.Title>
							</Dialog.Header>
							<Dialog.Body>
								<p>{errorDialog}</p>
							</Dialog.Body>
							<Dialog.Footer>
								<Dialog.ActionTrigger asChild>
									<Button
										ref={errorModalRef}
										ml={3}
										color={theme.colors.white}
										bg={theme.colors.blue[700]}
										_hover={{ backgroundColor: theme.colors.blue[800] }}
										onClick={() => setErrorDialog(null)}
									>
										Okay
									</Button>
								</Dialog.ActionTrigger>
							</Dialog.Footer>
							<Dialog.CloseTrigger asChild>
								<CloseButton size="sm" />
							</Dialog.CloseTrigger>
						</Dialog.Content>
					</Dialog.Positioner>
				</Portal>
			</Dialog.Root>
			<HStack spacing={2} justify="flex-end" p={2}>
				<VStack spacing="8px" mb="24px" align="flex-start">
					<Heading size="lg" pt="24px" textTransform="capitalize" color={theme.colors.blue[700]}>
						{formTitle} Attachments
					</Heading>
					<Text>{packetTitle}</Text>
				</VStack>
				<Spacer />
			</HStack>
			<Separator />
			<Tabs.Root lazyMount unmountOnExit defaultValue={attachmentLabels[attachmentsIndex]} pt="24px">
				<Tabs.List>
					{attachmentLabels.map((label, index) => (
						<Tabs.Trigger
							key={index}
							value={label}
							textTransform="capitalize"
							onClick={() => {
								console.log(index);
								setAttachmentsIndex(index);
							}}
						>
							{label === 'comments' ? 'notes' : label}
						</Tabs.Trigger>
					))}
				</Tabs.List>
				<Tabs.Content value="members">Manage your team members</Tabs.Content>
				<Tabs.Content value="projects">Manage your projects</Tabs.Content>
				{Object.entries(attachments).map(([label, attachmentList], index) => {
					const Renderer = Attachments[index];

					return (
						<Tabs.Content key={index} p={0} value={label}>
							<Renderer
								attachments={attachmentList.filter(
									({ formId }) => !currentFormId || currentFormId === formId
								)}
								formTitle={formTitle}
								attachmentType={attachmentLabels[attachmentsIndex]}
								currentPacketId={currentPacketId}
								currentFormId={currentFormId}
								activeLog={activeLog}
								saveForm={saveForm}
								navDrawerEnabled={navDrawerEnabled}
								navDrawerOpen={navDrawerOpen}
								readOnly={readOnly}
								currentProject={currentProject}
								currentPhase={currentPhase}
								addAttachment={addAttachment}
								removeAttachment={(id, attachmentType) => {
									deleteAttachment(currentPacketId, id)
										.then(() => saveForm({ id, type: attachmentType }, true, true))
										.catch(error => setErrorDialog(error.message));
								}}
							/>
						</Tabs.Content>
					);
				})}
			</Tabs.Root>
		</Box>
	);
};
